import { fetchWallets, chainsForNamespace } from "./api.js";
import { mapWallet } from "./mapWallet.js";
import { SLUGS_TO_FILTER } from "../../constants.js";
export async function resolveWalletConnectWallets(opts) {
    const chains = opts.chainIds?.join(',')
        || (opts.namespace ? chainsForNamespace(opts.namespace) : undefined);
    const projectId = opts.projectId;
    const response = await fetchWallets({
        page: opts.page ?? 1,
        entries: opts.entries ?? 40,
        chains: chains || undefined,
        search: opts.search,
        projectId,
    });
    const wallets = response.data
        .map((wallet) => mapWallet(wallet, projectId))
        .filter(w => !SLUGS_TO_FILTER.includes(w.id));
    return {
        wallets,
        totalCount: response.count,
        nextPage: response.nextPage,
    };
}
